import React, { lazy, Suspense } from "react";

const Home = lazy(() => import("../components/About_Laz"));

const renderLoader = () => <p>Loading</p>;

const HomeScreen = () => {
  return (
    <>
      <Suspense fallback={renderLoader()}>
        <Home />
      </Suspense>
    </>
  );
};

export default HomeScreen;
